import _defineProperty from '@babel/runtime/helpers/defineProperty';
import './components/index.js';
import { PageCount } from './components/PageCount/PageCount.js';
import { PrevButton } from './components/NavigationButton/components/PrevButton/PrevButton.js';
import { NextButton } from './components/NavigationButton/components/NextButton/NextButton.js';
import { Item } from './components/Item/Item.js';
import { Container } from './components/Container/Container.js';
import { Root } from './components/Root/Root.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CarouselV3 = {
  Root: Root,
  Container: Container,
  Item: Item,
  NextButton: NextButton,
  PrevButton: PrevButton,
  PageCount: PageCount
};

/**
 * CarouselV3 is under development. please connect with us before using it and it still not ready for production.
 */
var BetaCarouselV3 = _objectSpread({}, CarouselV3);

export { BetaCarouselV3, CarouselV3 };
//# sourceMappingURL=CarouselV3.js.map
